<template>
  <div>
    <b-row class="mt-3">
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col class="my-3">
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  :placeholder="$t('globals.type_to_search')"
                />
                <b-input-group-append>
                  <b-btn
                    variant="warning"
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    {{ $t("globals.clear") }}
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" class="my-3">
              <b-form-select v-model="perPage" :options="perPageOptions" />
            </b-col>
          </b-row>
          <b-table
            class="mt-3"
            bordered
            small
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items="events"
            :fields="fields"
            :filter="filter"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:cell(created_at)="item">
              <div v-b-tooltip.hover :title="item.item.created_at">
                {{ item.item.created_at.substring(0, 10) }}
              </div>
            </template>
            <template v-slot:cell(sold_at)="item">
              <div v-if="item.item.sold_at" v-b-tooltip.hover :title="item.item.sold_at">
                {{ item.item.sold_at.substring(0, 10) }}
              </div>
            </template>
            <template v-slot:cell(order)="item">
              <div v-if="item.item.order">
                <router-link
                  style="color:#17a2b8"
                  :to="{name: 'order', params:{ id: item.item.order.id }}"
                  target="_blank"
                >
                  <i>{{ item.item.order.order_no }}</i>
                </router-link>
              </div>
            </template>
            <template v-slot:cell(customer)="item">
              <div v-if="item.item.order">
                <router-link
                  style="color:#17a2b8"
                  :to="{name: 'customer', params:{ id: item.item.customer.id }}"
                  target="_blank"
                >
                  <i>{{ item.item.customer.company_name }}</i>
                </router-link>
              </div>
            </template>
            <template v-slot:cell(brand)="item">
              <div v-if="item.item.brand">
                <ulu-logo :brand="item.item.brand" scale="1.2"/>
              </div>
            </template>
            <template v-slot:cell(del)="item">
              <div v-if="item.item.status=='sold' || item.item.status=='sold_lease'">
                <b-btn
                  class="float-right"
                  size="sm"
                  variant="danger"
                  @click="deleteSold(item.item.id)"
                >
                  <v-icon name="trash"></v-icon>
                </b-btn>
              </div>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="events.length"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  components: {
    "ulu-logo": () => import("@/components/common/Logo.vue")
  },
  props: {
    events: Array,
    refresh: Function
  },
  data() {
    return {
      sortBy: "created_at",
      sortDesc: true,
      filter: null,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [
        { text: "10 " + this.$t("globals.per_page"), value: 10 },
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "30 " + this.$t("globals.per_page"), value: 30 }
      ],
      fields: [
        {
          key: "agent.full_name",
          label: this.$t("globals.agent")
        },
        {
          key: "brand",
          label: this.$t("globals.brand")
        },
        {
          key: "status",
          label: this.$t("globals.status")
        },
        {
          key: "order",
          label: this.$t("globals.order")
        },
        {
          key: "customer",
          label: this.$t("globals.customer")
        },
        {
          key: "sold_at",
          label: this.$t("globals.sold_at")
        },
        {
          key: "created_at",
          label: this.$t("globals.created"),
          sortable: true
        },
        {
          key: "del",
          label: "Del."
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    deleteSold(id) {
      let data = {
        query: `
          mutation { 
            res: DeviceEventDeleteSold (
              event_id: ${parseInt(id)}
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.refresh();
      });
    }
  }
};
</script>
